import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import { signin, verify, getUserInfo } from "../auth/helper";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Login = ({ isOpen, onClose, setToken }) => {
  const [mobile, setMobile] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOTP] = useState('');
  const desktopRefs = useRef(new Array(4));
  const mobileRefs = useRef(new Array(4));
  const [isOTPRight, setIsOTPRight] = useState(true);
  const [remainingTime, setRemainingTime] = useState(0);
  const [isNumberExists, setIsNumberExists] = useState(true);

  const navigate = useNavigate();

  const navigateHome = () => {
    navigate('/');
  };

  const handleMobileChange = (event) => {
    const value = event.target.value;
    if (value.length <= 11) {
      setMobile(value);
      setShowOtp(false);
      setIsOTPRight(true);
      setOTP('');
    }
  };

  const handleInput = (event, index, refs) => {
    let value = event.target.value;
    const persianToEnglish = (str) => str.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    value = persianToEnglish(value);
    const newOtp = otp.split("");
    newOtp[index] = value;
    setOTP(newOtp.join(""));
    
    if (value.length === 1 && index < 3 && refs.current[index + 1]) {
      refs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index, refs) => {
    if (event.key === "Backspace" && !otp[index]) {
      event.preventDefault();
      if (index > 0 && refs.current[index - 1]) {
        refs.current[index - 1].focus();
      }
      const newOtp = otp.split("");
      newOtp[index] = "";
      setOTP(newOtp.join(""));
    }
  };

  const handlePaste = (event, refs) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData("text/plain").slice(0, 4);
    setOTP(pasteData);

    pasteData.split("").forEach((char, index) => {
      if (refs.current[index]) {
        refs.current[index].value = char;
      }
    });
  };

  const onSubmit = (event) => {
    setOTP('');
    event.preventDefault();
    if (mobile.length === 11) {
      signin(mobile)
      .then((data) => {
        console.log(data)
          if(data.message === "There is no user with this phone number"){
            setIsNumberExists(false);
          }
          else if(data.message === "OTP was sent"){
            setIsNumberExists(true);
            setIsOTPRight(true);
            setShowOtp(true);
          }
      })
      .catch((e) => console.log(e));
    }
  };

  const onSubmitVerify = (event) => {
    event.preventDefault();
    verify( mobile , otp )
      .then((data) => {
        console.log(data)
        if(data === "OTP is wrong"){
          setIsOTPRight(false);
          setRemainingTime(10);
        }
        else{
          setIsOTPRight(true);
          setToken(data.token);
          Cookies.set('token', data.token, { expires: 365 });
          setMobile('')
          setOTP('')
          setShowOtp(false)
          setIsOTPRight(true)
          setRemainingTime(0)
          setIsNumberExists(true)
          onClose();
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (!isOpen) {
      setMobile('');
      setOTP('');
      setShowOtp(false);
      setIsOTPRight(true);
      setRemainingTime(0);
      setIsNumberExists(true);
    }
  }, [isOpen]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (remainingTime > 0) {
        setRemainingTime((prev) => prev - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [remainingTime]);

  if (!isOpen) return null;

  console.log(otp)

  return (
    <>
      <div className="modal-overlay-login" onClick={onClose}>
        <div className="modal-content-login" onClick={(e) => e.stopPropagation()}>
          <svg className="login-svg" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M69.3019 27.2673L42.9843 18.4948C40.2862 17.5954 37.5 19.6036 37.5 22.4476V77.5524C37.5 80.3964 40.2862 82.4046 42.9843 81.5053L69.3019 72.7327C72.7047 71.5984 75 68.4139 75 64.827V35.173C75 31.5861 72.7047 28.4016 69.3019 27.2673Z" fill="#3CCFF1" fill-opacity="0.5" />
            <path d="M47.9163 39.5833L58.333 50M58.333 50L47.9163 60.4166M58.333 50H16.6663" stroke="#E53B1F" stroke-width="4.16667" stroke-linecap="round" />
          </svg>
          <p className="login-title">ورود به حساب کاربری</p>
          <div className="login-horizontal-line"></div>

          <div className="login-input-container">
            <p className="login-label">شماره تماس خود را وارد نمایید</p>
            <input type="tel" id="mobile" name="mobile" placeholder="شماره تماس" className="login-input" value={mobile} onChange={handleMobileChange} />
            {!isNumberExists && <p className="error-message">شماره وجود نداره!</p>}
            <p className="login-label">کد ارسالی را وارد نمایید</p>
          </div>
          
          {!showOtp && (
            <div className="otp-container-send">
            <button onClick={onSubmit} className={`send-code-button ${mobile.length !== 11 ? "disabled" : ''}`} disabled={mobile.length !== 11}>ارسال کد</button>
            <form className="form-otp">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index] || ''}
                    onChange={(event) => handleInput(event, index, desktopRefs)}
                    onKeyDown={(event) => handleKeyDown(event, index, desktopRefs)}
                    onPaste={(event) => handlePaste(event, desktopRefs)}
                    ref={(el) => (desktopRefs.current[index] = el)}
                    className="otp-input disabled"
                    disabled
                  />
                ))}
            </form>
            </div>
          )}

          {showOtp && isOTPRight && (
            <>
            <div className="otp-container-send">
            <button onClick={onSubmitVerify} className="send-code-button">تایید</button>
            <form className="form-otp">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index] || ''}
                    onChange={(event) => handleInput(event, index, desktopRefs)}
                    onKeyDown={(event) => handleKeyDown(event, index, desktopRefs)}
                    onPaste={(event) => handlePaste(event, desktopRefs)}
                    ref={(el) => (desktopRefs.current[index] = el)}
                    className="otp-input"
                  />
                ))}
            </form>
            </div>
            </>
          )}

          {showOtp && !isOTPRight &&(
            <>
            <div className="otp-container-send">
            <button onClick={onSubmit} className={`send-code-button ${remainingTime !== 0 ? "disabled" : ''}`} disabled={remainingTime !== 0}>
              {remainingTime === 0 ? "ارسال مجدد" : `(${remainingTime} ثانیه)`}
            </button>
            <form className="form-otp">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index] || ''}
                    onChange={(event) => handleInput(event, index, desktopRefs)}
                    onKeyDown={(event) => handleKeyDown(event, index, desktopRefs)}
                    onPaste={(event) => handlePaste(event, desktopRefs)}
                    ref={(el) => (desktopRefs.current[index] = el)}
                    className="otp-input"
                  />
                ))}
            </form>
            </div>
            {!isOTPRight && isNumberExists && <p className="error-message">کد وارد شده صحیح نیست</p>}
            </>
          )}
        </div>
      </div>

      <div className="modal-overlay-login-mobile" onClick={onClose}>
        <div className="modal-content-login-mobile" onClick={(e) => e.stopPropagation()}>
          <svg className="login-svg-mobile" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M69.3019 27.2673L42.9843 18.4948C40.2862 17.5954 37.5 19.6036 37.5 22.4476V77.5524C37.5 80.3964 40.2862 82.4046 42.9843 81.5053L69.3019 72.7327C72.7047 71.5984 75 68.4139 75 64.827V35.173C75 31.5861 72.7047 28.4016 69.3019 27.2673Z" fill="#3CCFF1" fill-opacity="0.5" />
            <path d="M47.9163 39.5833L58.333 50M58.333 50L47.9163 60.4166M58.333 50H16.6663" stroke="#E53B1F" stroke-width="4.16667" stroke-linecap="round" />
          </svg>
          <p className="login-title-mobile">ورود به حساب کاربری</p>
          <div className="login-horizontal-line"></div>

          <div className="login-input-container">
            <p className="login-label-mobile">شماره تماس خود را وارد نمایید</p>
            <input type="tel" id="mobile" name="mobile" placeholder="شماره تماس" className="login-input-mobile" value={mobile} onChange={handleMobileChange} />
            {!isNumberExists && <p className="error-message-mobile">شماره وجود نداره!</p>}
            <p className="login-label-mobile">کد ارسالی را وارد نمایید</p>
          </div>
          
          {!showOtp && (
            <div className="otp-container-send">
            <button onClick={onSubmit} className={`send-code-button-mobile ${mobile.length !== 11 ? "disabled" : ''}`} disabled={mobile.length !== 11}>ارسال کد</button>
            <form className="form-otp-mobile">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index] || ''}
                    onChange={(event) => handleInput(event, index, mobileRefs)}
                    onKeyDown={(event) => handleKeyDown(event, index, mobileRefs)}
                    onPaste={(event) => handlePaste(event, mobileRefs)}
                    ref={(el) => (mobileRefs.current[index] = el)}
                    className="otp-input-mobile disabled"
                    disabled
                  />
                ))}
            </form>
            </div>
          )}

          {showOtp && isOTPRight && (
            <>
            <div className="otp-container-send">
            <button onClick={onSubmitVerify} className="send-code-button-mobile">تایید</button>
            <form className="form-otp-mobile">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index] || ''}
                    onChange={(event) => handleInput(event, index, mobileRefs)}
                    onKeyDown={(event) => handleKeyDown(event, index, mobileRefs)}
                    onPaste={(event) => handlePaste(event, mobileRefs)}
                    ref={(el) => (mobileRefs.current[index] = el)}
                    className="otp-input-mobile"
                  />
                ))}
            </form>
            </div>
            </>
          )}

          {showOtp && !isOTPRight &&(
            <>
            <div className="otp-container-send">
            <button onClick={onSubmit} className={`send-code-button-mobile ${remainingTime !== 0 ? "disabled" : ''}`} disabled={remainingTime !== 0}>
              {remainingTime === 0 ? "ارسال مجدد" : `(${remainingTime} ثانیه)`}
            </button>
            <form className="form-otp-mobile">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={otp[index] || ''}
                    onChange={(event) => handleInput(event, index, mobileRefs)}
                    onKeyDown={(event) => handleKeyDown(event, index, mobileRefs)}
                    onPaste={(event) => handlePaste(event, mobileRefs)}
                    ref={(el) => (mobileRefs.current[index] = el)}
                    className="otp-input-mobile"
                  />
                ))}
            </form>
            </div>
            {!isOTPRight && isNumberExists && <p className="error-message-mobile">کد وارد شده صحیح نیست</p>}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Login;


